/**
 * Removes wrapping single or double quotes from serialized string values.
 * Returns the trimmed value unchanged if no wrapping quotes are found.
 */
export const sanitizeDisplayText = (value?: string): string | undefined => {
  if (!value) return value;

  const trimmed = value.trim();
  if (trimmed.length < 2) return trimmed;

  const first = trimmed[0];
  const last = trimmed[trimmed.length - 1];
  const firstIsQuote = first === '"' || first === "'";
  const lastIsQuote = last === '"' || last === "'";

  if (firstIsQuote || lastIsQuote) {
    return trimmed.slice(firstIsQuote ? 1 : 0, lastIsQuote ? -1 : undefined);
  }

  return trimmed;
};
